import styled from 'styled-components'

const PaymentMethodsUi = styled.div`
  --payment-method-border-color: #bfc6d1;
  border: 1px solid var(--payment-method-border-color);
  border-radius: 5px;
`

export default PaymentMethodsUi
